"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BackgroundLayerChooser = void 0;
var _react = _interopRequireWildcard(require("react"));
var _OverviewMap = _interopRequireDefault(require("ol/control/OverviewMap"));
var _View = _interopRequireDefault(require("ol/View"));
var _Tile = _interopRequireDefault(require("ol/layer/Tile"));
var _Image = _interopRequireDefault(require("ol/layer/Image"));
var _util = require("ol/util");
var _BackgroundLayerPreview = _interopRequireDefault(require("../BackgroundLayerPreview/BackgroundLayerPreview"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _useMap = _interopRequireDefault(require("../Hook/useMap"));
var _SimpleButton = _interopRequireDefault(require("../Button/SimpleButton/SimpleButton"));
require("./BackgroundLayerChooser.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var BackgroundLayerChooser = exports.BackgroundLayerChooser = function BackgroundLayerChooser(_ref) {
  var _map$getView, _map$getView2;
  var layers = _ref.layers,
    _ref$allowEmptyBackgr = _ref.allowEmptyBackground,
    allowEmptyBackground = _ref$allowEmptyBackgr === void 0 ? false : _ref$allowEmptyBackgr,
    _ref$buttonTooltip = _ref.buttonTooltip,
    buttonTooltip = _ref$buttonTooltip === void 0 ? 'Change background layer' : _ref$buttonTooltip,
    initiallySelectedLayer = _ref.initiallySelectedLayer,
    _ref$noBackgroundTitl = _ref.noBackgroundTitle,
    noBackgroundTitle = _ref$noBackgroundTitl === void 0 ? 'No Background' : _ref$noBackgroundTitl,
    _ref$backgroundLayerF = _ref.backgroundLayerFilter,
    backgroundLayerFilter = _ref$backgroundLayerF === void 0 ? function (l) {
      return !!l.get('isBackgroundLayer');
    } : _ref$backgroundLayerF;
  var map = (0, _useMap["default"])();
  var mapTarget = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(map === null || map === void 0 || (_map$getView = map.getView()) === null || _map$getView === void 0 ? void 0 : _map$getView.getZoom()),
    _useState2 = _slicedToArray(_useState, 2),
    zoom = _useState2[0],
    setZoom = _useState2[1];
  var _useState3 = (0, _react.useState)(map === null || map === void 0 || (_map$getView2 = map.getView()) === null || _map$getView2 === void 0 ? void 0 : _map$getView2.getCenter()),
    _useState4 = _slicedToArray(_useState3, 2),
    center = _useState4[0],
    setCenter = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    layerOptionsVisible = _useState6[0],
    setLayerOptionsVisible = _useState6[1];
  var _useState7 = (0, _react.useState)(initiallySelectedLayer),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedLayer = _useState8[0],
    setSelectedLayer = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isBackgroundImage = _useState10[0],
    setIsBackgroundImage = _useState10[1];
  (0, _react.useEffect)(function () {
    if (map) {
      var centerListener = function centerListener(evt) {
        if (layerOptionsVisible) {
          setCenter(evt.target.getCenter());
        }
      };
      var resolutionListener = function resolutionListener(evt) {
        if (layerOptionsVisible) {
          setZoom(evt.target.getZoom());
        }
      };
      map.getView().on('change:center', centerListener);
      map.getView().on('change:resolution', resolutionListener);
      return function () {
        map.getView().un('change:center', centerListener);
        map.getView().un('change:resolution', resolutionListener);
      };
    }
    return;
  }, [map, layerOptionsVisible]);
  (0, _react.useEffect)(function () {
    var activeLayerCand = layers.find(function (l) {
      return l.getVisible();
    });
    if (!initiallySelectedLayer) {
      setSelectedLayer(activeLayerCand);
    }
  }, [layers]);
  (0, _react.useEffect)(function () {
    if (selectedLayer && map) {
      var existingControl = map.getControls().getArray().find(function (c) {
        return c instanceof _OverviewMap["default"];
      });
      if (existingControl) {
        map.removeControl(existingControl);
      }
      var ovLayer;
      if (selectedLayer instanceof _Tile["default"]) {
        ovLayer = new _Tile["default"]({
          source: selectedLayer.getSource()
        });
      } else if (selectedLayer instanceof _Image["default"]) {
        ovLayer = new _Image["default"]({
          source: selectedLayer.getSource()
        });
      }
      if (ovLayer && mapTarget.current) {
        var overViewControl = new _OverviewMap["default"]({
          collapsible: false,
          target: mapTarget.current,
          className: 'ol-overviewmap react-geo-bg-layer-chooser-overviewmap',
          layers: [ovLayer],
          view: new _View["default"]({
            projection: map.getView().getProjection()
          })
        });
        map.addControl(overViewControl);
      }
    }
  }, [selectedLayer]);
  var onLayerSelect = function onLayerSelect(layer) {
    setLayerOptionsVisible(false);
    setSelectedLayer(layer);
    setIsBackgroundImage(false);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'bg-layer-chooser'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "layer-cards",
    style: {
      maxWidth: layerOptionsVisible ? '100vw' : 0,
      opacity: layerOptionsVisible ? 1 : 0,
      visibility: layerOptionsVisible ? 'visible' : 'hidden'
    }
  }, layers.map(function (layer) {
    return /*#__PURE__*/_react["default"].createElement(_BackgroundLayerPreview["default"], {
      key: (0, _util.getUid)(layer),
      activeLayer: selectedLayer,
      onClick: function onClick(l) {
        return onLayerSelect(l);
      },
      layer: layer,
      backgroundLayerFilter: backgroundLayerFilter,
      zoom: zoom,
      center: center
    });
  }), allowEmptyBackground && /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    onMouseOver: function onMouseOver() {
      selectedLayer === null || selectedLayer === void 0 || selectedLayer.setVisible(false);
    },
    onClick: function onClick() {
      selectedLayer === null || selectedLayer === void 0 || selectedLayer.setVisible(false);
      setSelectedLayer(undefined);
      setLayerOptionsVisible(false);
      setIsBackgroundImage(true);
    },
    className: "no-background"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faBan,
    size: "5x"
  }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
    className: "layer-title"
  }, noBackgroundTitle))), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    className: "change-bg-btn".concat(layerOptionsVisible ? ' toggled' : ''),
    size: "small",
    tooltip: buttonTooltip,
    icon: layerOptionsVisible ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faChevronRight
    }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faChevronLeft
    }),
    onClick: function onClick() {
      return setLayerOptionsVisible(!layerOptionsVisible);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-preview"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "overview-wrapper"
  }, !isBackgroundImage ? /*#__PURE__*/_react["default"].createElement("div", {
    id: "overview-map",
    ref: mapTarget
  }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "no-background-preview",
    icon: _freeSolidSvgIcons.faBan,
    size: "5x"
  }), selectedLayer ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "layer-title"
  }, selectedLayer.get('name')) : /*#__PURE__*/_react["default"].createElement("span", {
    className: "layer-title-no-background"
  }, noBackgroundTitle))));
};
var _default = exports["default"] = BackgroundLayerChooser;